export class LimitedCache {
  constructor(capacity) {
    if (capacity === void 0) {
      capacity = 0;
    }
    this._cache = new Map();
    this._keysKeeper = [];
    this._capacity = Math.max(capacity, 0);
  }
  set(key, value) {
    if (this._capacity === 0) {
      return;
    }
    const keyIndex = this._keysKeeper.indexOf(key);
    if (keyIndex === -1) {
      const length = this._keysKeeper.push(key);
      if (length > this._capacity) {
        const keyToDelete = this._keysKeeper.shift();
        this.delete(keyToDelete);
      }
    }
    this._cache.set(key, value);
  }
  delete(key) {
    this._cache.delete(key);
  }
  clear() {
    this._cache.clear();
    this._keysKeeper.length = 0;
  }
  get(key) {
    return this._cache.get(key);
  }
  has(key) {
    return this._cache.has(key);
  }
  size() {
    return this._keysKeeper.length;
  }
}